/**
 * Mobile Menu Phonics USP Injection
 * 
 * Injects promotional content into Replo mobile menu
 * Winner implementation - displays to all users
 */

(function() {
  'use strict';

  // Global flag to prevent duplicate initialization
  if (window.__TSS013_INITIALIZED__) {
    return;
  }
  window.__TSS013_INITIALIZED__ = true;

  // Component HTML template
  const componentHTML = `
    <div class="menu-phonics-usp" data-testid="tss-013">
      <p class="menu-phonics-usp__headline">
        The only phonics resource proven to accelerate literacy growth and aligned to the Science of Reading.
      </p>
      
      <ul class="menu-phonics-usp__list">
        <li class="menu-phonics-usp__item">
          <span class="svg-wrapper menu-phonics-usp__icon">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_2062_24624)">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M6.31403 9.48635L12.8299 3.2L14.48 4.91064L6.30268 12.8L1.51929 8.12213L3.18116 6.42242L6.31403 9.48635Z" fill="#2BA53B"/>
            </g>
            <defs>
            <clipPath id="clip0_2062_24624">
            <rect width="16" height="16" fill="white"/>
            </clipPath>
            </defs>
            </svg>
          </span>
          <span class="menu-phonics-usp__text">Serves All Skill Levels</span>
        </li>
        
        <li class="menu-phonics-usp__item">
          <span class="svg-wrapper menu-phonics-usp__icon">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_2062_24624)">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M6.31403 9.48635L12.8299 3.2L14.48 4.91064L6.30268 12.8L1.51929 8.12213L3.18116 6.42242L6.31403 9.48635Z" fill="#2BA53B"/>
            </g>
            <defs>
            <clipPath id="clip0_2062_24624">
            <rect width="16" height="16" fill="white"/>
            </clipPath>
            </defs>
            </svg>
          </span>
          <span class="menu-phonics-usp__text">Easy To Implement (No Curriculum Replacement)</span>
        </li>
        
        <li class="menu-phonics-usp__item">
          <span class="svg-wrapper menu-phonics-usp__icon">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_2062_24624)">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M6.31403 9.48635L12.8299 3.2L14.48 4.91064L6.30268 12.8L1.51929 8.12213L3.18116 6.42242L6.31403 9.48635Z" fill="#2BA53B"/>
            </g>
            <defs>
            <clipPath id="clip0_2062_24624">
            <rect width="16" height="16" fill="white"/>
            </clipPath>
            </defs>
            </svg>
          </span>
          <span class="menu-phonics-usp__text">2+ Grade Level Reading Gains</span>
        </li>
        
        <li class="menu-phonics-usp__item">
          <span class="svg-wrapper menu-phonics-usp__icon">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_2062_24624)">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M6.31403 9.48635L12.8299 3.2L14.48 4.91064L6.30268 12.8L1.51929 8.12213L3.18116 6.42242L6.31403 9.48635Z" fill="#2BA53B"/>
            </g>
            <defs>
            <clipPath id="clip0_2062_24624">
            <rect width="16" height="16" fill="white"/>
            </clipPath>
            </defs>
            </svg>
          </span>
          <span class="menu-phonics-usp__text">Measurable Results in 3 Months</span>
        </li>
      </ul>
    </div>
  `;

  // Component is always visible (winner implementation)
  function shouldShowComponent() {
    return true;
  }

  // Find potential mobile menu containers (Replo or standard)
  function findMobileMenuContainer() {
    const selectors = [
      // Replo V2 mobile menu - specific class pattern
      '.r-ib1cn0',
      // Replo mobile menu with collapsibles
      '[data-replo-collapsible]',
      // Replo alchemy element
      '.alchemy__element [class*="r-"]',
      // Replo mobile menu selectors
      '[data-replo-mobile-menu]',
      '[class*="mobile-menu"]',
      '[class*="drawer"]',
      // Standard Shopify selectors as fallback
      '#menu-drawer .menu-drawer__navigation-container',
      '.menu-drawer__navigation-container',
      '#menu-drawer .menu-drawer__inner-container',
    ];

    for (const selector of selectors) {
      const container = document.querySelector(selector);
      if (container) {
        return container;
      }
    }

    return null;
  }

  // Inject the component into the mobile menu
  function injectComponent() {
    // Check if already injected (by any script instance)
    if (document.querySelector('[data-testid="tss-013"]')) {
      return;
    }

    const container = findMobileMenuContainer();
    if (!container) {
      return;
    }

    // Create wrapper element
    const wrapper = document.createElement('div');
    wrapper.innerHTML = componentHTML;
    const component = wrapper.firstElementChild;

    // Verify component was created successfully
    if (!component) {
      return;
    }

    // Verify container is still valid before appending
    if (!container.parentNode) {
      return;
    }

    // Append at the end of container
    try {
      container.appendChild(component);
    } catch (error) {
      console.error('[TSS-013] Failed to inject component:', error);
    }
  }

  // Watch for Replo re-renders that might remove the component
  function observeContainerChanges() {
    const container = findMobileMenuContainer();
    if (!container) return;

    let reinjectionCount = 0;

    const observer = new MutationObserver(function(mutations) {
      // Check if our component still exists
      const component = document.querySelector('[data-testid="tss-013"]');
      if (!component && shouldShowComponent()) {
        reinjectionCount++;
        injectComponent();
      }
    });

    observer.observe(container, {
      childList: true,
      subtree: true
    });
  }

  // Track if component has been successfully injected
  let injectionComplete = false;

  // Initialize - try multiple times as Replo may load dynamically
  function init() {
    if (injectionComplete) {
      return;
    }

    let attempts = 0;
    const maxAttempts = 20;
    const interval = 200; // Check every 200ms

    const tryInject = setInterval(function() {
      if (injectionComplete) {
        clearInterval(tryInject);
        return;
      }

      attempts++;
      
      const container = findMobileMenuContainer();
      if (container && !document.querySelector('[data-testid="tss-013"]')) {
        clearInterval(tryInject);
        injectComponent();
        observeContainerChanges();
        injectionComplete = true;
      } else if (attempts >= maxAttempts) {
        clearInterval(tryInject);
      }
    }, interval);
  }

  // Start when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Also try on window load in case Replo loads late
  window.addEventListener('load', function() {
    if (!injectionComplete) {
      setTimeout(function() {
        if (!injectionComplete && !document.querySelector('[data-testid="tss-013"]')) {
          injectComponent();
          observeContainerChanges();
          injectionComplete = true;
        }
      }, 1000);
    }
  });

})();
